import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PHONE_DISPLAY, ADDRESS_LINE1, ADDRESS_LINE2 } from "@/lib/campaign";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[var(--brand-bg)]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12 text-left">
        <Link
          data-testid="privacy-back-link"
          to="/menopause"
          className="inline-flex items-center gap-2 text-base font-medium text-[var(--brand-navy)] hover:text-[var(--brand-gold)] transition-colors"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" /> Back
        </Link>
        <h1 className="mt-6 font-serif-brand text-3xl sm:text-4xl font-medium text-[var(--brand-navy)]">
          Privacy and data practices for this page
        </h1>
        <div className="mt-8 space-y-6 text-base sm:text-lg leading-relaxed">
          <section>
            <h2 className="font-serif-brand text-xl font-medium text-[var(--brand-navy)] mb-2">
              What this page collects
            </h2>
            <p>
              If you send a question through the contact form, we collect your name, email, optional
              phone number, and the message you write. You can review and edit the entire message,
              including any prefilled summary from the appointment guide, before anything is sent.
            </p>
          </section>
          <section>
            <h2 className="font-serif-brand text-xl font-medium text-[var(--brand-navy)] mb-2">
              Where your message goes
            </h2>
            <p>
              Contact form messages are delivered by email to the team at All-In Precision Wellness
              and to the practice&rsquo;s website agency, Bliss Branding, which helps manage these
              inquiries on the practice&rsquo;s behalf.
            </p>
          </section>
          <section>
            <h2 className="font-serif-brand text-xl font-medium text-[var(--brand-navy)] mb-2">
              The appointment guide
            </h2>
            <p>
              Your selections in the appointment guide stay in your browser during your session.
              They are not written to web addresses, stored after you leave, or sent anywhere unless
              you choose to include them in a message to the office.
            </p>
          </section>
          <section>
            <h2 className="font-serif-brand text-xl font-medium text-[var(--brand-navy)] mb-2">
              Measurement
            </h2>
            <p>
              We count anonymous page activity, such as page views and button clicks, in our own
              systems to understand whether this page is helpful. These counts contain no names,
              health concerns, or guide answers. This page uses no advertising pixels, session
              recording, or health-related audience tracking.
            </p>
          </section>
          <section>
            <h2 className="font-serif-brand text-xl font-medium text-[var(--brand-navy)] mb-2">
              Questions
            </h2>
            <p>
              Call {PHONE_DISPLAY} or write to the office at {ADDRESS_LINE1}, {ADDRESS_LINE2}.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
